const ShowcasingLanguages = [
    { value: 'danish', label: 'Dansk' },
    { value: 'english', label: 'English' }
];

export default ShowcasingLanguages;